export enum BookViewMutationTypes {
  BOOK_STORE_SET_DATA = 'BOOK_STORE_SET_DATA',
  BOOK_STORE_CLEAR_DATA = 'BOOK_STORE_CLEAR_DATA',
  BOOK_STORE_SET_LOADING = 'BOOK_STORE_SET_LOADING',
  BOOK_STORE_SET_HEATMAP_DATA = 'BOOK_STORE_SET_HEATMAP_DATA',
  BOOK_STORE_SET_HEATMAP_LOADING = 'BOOK_STORE_SET_HEATMAP_LOADING',
  BOOK_STORE_SET_SETTINGS = 'BOOK_STORE_SET_SETTINGS',
  BOOK_STORE_SET_SLIDER_OPTIONS = 'BOOK_STORE_SET_SLIDER_OPTIONS',
  BOOK_STORE_RESET_DATA = 'BOOK_STORE_RESET_DATA',
}
